import { Link } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { FaFacebook, FaInstagram, FaLinkedin, FaWhatsapp, FaYoutube } from "react-icons/fa";
import { FiChevronRight, FiX } from "react-icons/fi";
import { IAllDebts, useBatchPayment } from "../../context/BatchPaymentContext";
import { Container, Content, ContentContact, ContentContactDetail, ContentContactTitle, ContentDetail, ContentTitle, DivDefaultModal, DivModalContent, ModalButton, ModalContentTitle, ModalDetail, ModalDetailContainer, ModalDetailContainerDebt, Summary, SummaryDebts, SummaryInstallment, SummaryOrder } from "./style";
import { useLocation } from "react-router-dom";
import { handleDebtsByType } from "../../utils/debtsProcessing";

interface IConsultInProgress {
    id: number;
    consulta: number;
    correlation: string;
    subUsuario: string;
    userPool: string;
    dataConsulta: any;
    placa: string;
    renavam: string;
    payloadConsulta: any;
    payloadCaptura: any;
    payloadComprovante: any;
    status: string;
    ip: string;
    email: string;
    origin: string;
    created_at: string;
    updated_at: string;
    deleted_at: string;
    recoveryEmailSent: boolean;
    isRecoveryConsult: boolean;
    subStatus: string;
    subStatusLastUpdated: string;
    paymentAttempts: boolean;
    idApiKey: number;
}

const Proof: FC = () => {
    const {
        allDebtsSelected,
        installments,
        ipvaTotal,
        dpvatTotal,
        multasTotal,
        outrosTotal,
        licenciamentoTotal,
        // consultCode,
    } = useBatchPayment();

    const [screenWidth, setScreenWidth] = useState<number>(0);

    const [modalDetail, showModalDetail] = useState(false);

    const location = useLocation();
    const { codigoPagamento, urlRecibo, autorizacao, clientId } = location?.state ?? {};

    const [hasAuthToShow, setHasAuthToShow] = useState('');
    const [hasPaymentCode, setHasPaymentCode] = useState(0);

    const [storeData, setStoreData] = useState<any>({});
    const [selectedForDetails, setSelectedForDetails] = useState<any>({});

    const [licenciamentoSelected, setLicenciamentoSelected] = useState<IAllDebts[]>(handleDebtsByType("licenciamento", allDebtsSelected))
    const [dpvatSelected, setDpvatSelected] = useState<IAllDebts[]>(handleDebtsByType("dpvat", allDebtsSelected))
    const [multasSelected, setMultasSelected] = useState<IAllDebts[]>(handleDebtsByType("multas", allDebtsSelected))
    const [outrosSelected, setOutrosSelected] = useState<IAllDebts[]>(handleDebtsByType("outros", allDebtsSelected))
    const [ipvaSelected, setIpvaSelected] = useState<IAllDebts[]>(handleDebtsByType("ipva", allDebtsSelected))

    useEffect(() => {
        const width = window.screen.width;
        window.addEventListener('resize', () => {
            setScreenWidth(window.innerWidth);
        });
        setScreenWidth(width);
    }, []);

    // # useEffect para verificar se a chamada do component é de uma Placa com consulta em andamento
    // - Foi pago com Cartão de Crédito e esta em PROCESSAMENTO no Banco de dados ##
    useEffect(() => {
        const storageConsultInProgress = window.localStorage.getItem(
            'zignet:ConsultInProgress'
        );

        if (storageConsultInProgress) {
            const consultInProgress: IConsultInProgress = JSON.parse(
                storageConsultInProgress
            );

            const debtsOnPayloadConsulta = consultInProgress.payloadConsulta?.debitos;
            const debtsOnPayloadCaptura = consultInProgress.payloadCaptura?.debitos;
            const listCodeDebtsOnPayloadCaptura = debtsOnPayloadCaptura.map(
                (each: any) => each.codigo
            );

            const dpvatSelected = debtsOnPayloadConsulta?.dpvat?.filter(
                (dpvat: any) =>
                    listCodeDebtsOnPayloadCaptura.includes(dpvat.codigo) && dpvat
            );
            const ipvaSelected = debtsOnPayloadConsulta?.ipva?.filter(
                (ipva: any) =>
                    listCodeDebtsOnPayloadCaptura.includes(ipva.codigo) && ipva
            );
            const licenciamentoSelected =
                debtsOnPayloadConsulta?.licenciamento?.filter(
                    (licenciamento: any) =>
                        listCodeDebtsOnPayloadCaptura.includes(licenciamento.codigo) &&
                        licenciamento
                );
            const multasSelected = debtsOnPayloadConsulta?.multas?.filter(
                (multa: any) =>
                    listCodeDebtsOnPayloadCaptura.includes(multa.codigo) && multa
            );
            const outrosSelected = debtsOnPayloadConsulta?.outros?.filter(
                (outros: any) =>
                    listCodeDebtsOnPayloadCaptura.includes(outros.codigo) && outros
            );

            setStoreData({
                consultCode: consultInProgress?.consulta,
                installments: {
                    quantity: consultInProgress?.payloadCaptura?.parcelas,
                    totalPrice: consultInProgress?.payloadCaptura?.valor
                },
                dpvatSelected,
                ipvaSelected,
                licenciamentoSelected,
                multasSelected,
                outrosSelected
            });

            setHasAuthToShow(consultInProgress?.payloadComprovante?.autorizacao);
            setHasPaymentCode(consultInProgress?.payloadComprovante?.codigoPagamento);
        }
    }, []);

    // # useEffect para verificar a origem dos detalhes a ser mostrado
    // - Se é de uma consulta finalizada ou de uma consulta em PROCESSAMENTO ##
    useEffect(() => {
        setSelectedForDetails({
            dpvatSelected:
                dpvatSelected.length > 0 ? dpvatSelected : storeData?.dpvatSelected,
            ipvaSelected:
                ipvaSelected.length > 0 ? ipvaSelected : storeData?.ipvaSelected,
            licenciamentoSelected:
                licenciamentoSelected.length > 0
                    ? licenciamentoSelected
                    : storeData?.licenciamentoSelected,
            multasSelected:
                multasSelected.length > 0 ? multasSelected : storeData?.multasSelected,
            outrosSelected:
                outrosSelected.length > 0 ? outrosSelected : storeData?.outrosSelected
        });
    }, [
        dpvatSelected,
        ipvaSelected,
        licenciamentoSelected,
        multasSelected,
        outrosSelected,
        storeData?.dpvatSelected,
        storeData?.ipvaSelected,
        storeData?.licenciamentoSelected,
        storeData?.multasSelected,
        storeData?.outrosSelected
    ]);

    return (
        <>
            {modalDetail &&
                <DivDefaultModal>
                    <DivModalContent>
                        <ModalContentTitle>Detalhes do pedido</ModalContentTitle>
                        <ModalDetail>
                            {selectedForDetails?.ipvaSelected?.length > 0 && (
                                <ModalDetailContainer>
                                    <h2>IPVA</h2>

                                    {selectedForDetails?.ipvaSelected?.map((ipva: any) => (
                                        <ModalDetailContainerDebt>
                                            <p>
                                                <strong>{ipva.uf}</strong> - {ipva.description} {ipva.additionalDescription && ipva.additionalDescription.length > 0 && " - " + ipva.additionalDescription}
                                            </p>
                                            <p>
                                                <strong>
                                                    {new Intl.NumberFormat('pt-BR', {
                                                        style: 'currency',
                                                        currency: 'BRL'
                                                    }).format(ipva.value)}
                                                </strong>
                                            </p>
                                        </ModalDetailContainerDebt>
                                    ))}
                                </ModalDetailContainer>
                            )}
                            {selectedForDetails?.dpvatSelected?.length > 0 && (
                                <ModalDetailContainer>
                                    <h2>DPVAT</h2>
                                    {selectedForDetails?.dpvatSelected?.map((dpvat: any) => (
                                        <ModalDetailContainerDebt>
                                            <p>
                                                <strong>{dpvat.uf}</strong>  - {dpvat.description} {dpvat.additionalDescription && dpvat.additionalDescription.length > 0 && " - " + dpvat.additionalDescription}
                                            </p>
                                            <p>
                                                <strong>
                                                    {new Intl.NumberFormat('pt-BR', {
                                                        style: 'currency',
                                                        currency: 'BRL'
                                                    }).format(dpvat.value)}
                                                </strong>
                                            </p>
                                        </ModalDetailContainerDebt>
                                    ))}
                                </ModalDetailContainer>
                            )}
                            {selectedForDetails?.multasSelected?.length > 0 && (
                                <ModalDetailContainer>
                                    <h2>Multas</h2>

                                    {selectedForDetails?.multasSelected?.map((multa: any) => (
                                        <ModalDetailContainerDebt>
                                            <p>
                                                <strong>{multa.uf}</strong>  - {multa.description} {multa.additionalDescription && multa.additionalDescription.length > 0 && " - " + multa.additionalDescription}
                                            </p>
                                            <p>
                                                <strong>
                                                    {new Intl.NumberFormat('pt-BR', {
                                                        style: 'currency',
                                                        currency: 'BRL'
                                                    }).format(multa.value)}
                                                </strong>
                                            </p>
                                        </ModalDetailContainerDebt>
                                    ))}
                                </ModalDetailContainer>
                            )}
                            {selectedForDetails?.licenciamentoSelected?.length > 0 && (
                                <ModalDetailContainer>
                                    <h2>Licenciamento</h2>

                                    {selectedForDetails?.licenciamentoSelected?.map(
                                        (licenciamento: any) => (
                                            <ModalDetailContainerDebt>
                                                <p>
                                                    <strong>{licenciamento.uf}</strong>  - {licenciamento.description} {licenciamento.additionalDescription && licenciamento.additionalDescription.length > 0 && " - " + licenciamento.additionalDescription}
                                                </p>
                                                <p>
                                                    <strong>
                                                        {new Intl.NumberFormat('pt-BR', {
                                                            style: 'currency',
                                                            currency: 'BRL'
                                                        }).format(licenciamento.value)}
                                                    </strong>
                                                </p>
                                            </ModalDetailContainerDebt>
                                        )
                                    )}
                                </ModalDetailContainer>
                            )}
                            {selectedForDetails?.outrosSelected?.length > 0 && (
                                <ModalDetailContainer>
                                    <h2>Outros</h2>

                                    {selectedForDetails?.outrosSelected?.map((outro: any) => (
                                        <ModalDetailContainerDebt>
                                            <p>
                                                <strong>{outro.uf}</strong>  - {outro.description} {outro.additionalDescription && outro.additionalDescription.length > 0 && " - " + outro.additionalDescription}
                                            </p>
                                            <p>
                                                <strong>
                                                    {new Intl.NumberFormat('pt-BR', {
                                                        style: 'currency',
                                                        currency: 'BRL'
                                                    }).format(outro.value)}
                                                </strong>
                                            </p>
                                        </ModalDetailContainerDebt>
                                    ))}
                                </ModalDetailContainer>
                            )}
                        </ModalDetail>
                        <ModalButton>
                            <button
                                onClick={() => {
                                    showModalDetail(false);
                                }}
                            >
                                Fechar
                                <FiX />
                            </button>
                        </ModalButton>
                    </DivModalContent>
                </DivDefaultModal>
            }
            <Container>
                <Content>
                    <ContentTitle>
                        <p>Parcelamento online</p>
                        <p>
                            Status do seu pedido:{' '}
                            <span>{codigoPagamento ? 'APROVADO' : 'EM PROCESSAMENTO'}</span>
                            {/* <span>EM PROCESSAMENTO</span> */}
                        </p>
                    </ContentTitle>
                    <ContentDetail>
                        {!codigoPagamento ? (
                            <>
                                <div>
                                    <h4>Pedido em processamento</h4>
                                    <p>
                                        O seu pedido está em análise e a confirmação ocorrerá em
                                        até 48 horas, prazo que consideramos hábil para validar as
                                        informações necessárias. Acompanhe pelo e-mail informado
                                        as etapas do seu pedido.
                                        <br /> <br />
                                        Você pode a qualquer momento consultar o status do pedido,
                                        usando os mesmos dados de veículo e proprietário deste
                                        pedido.
                                    </p>
                                </div>
                                <div>
                                    <h4>Atenção</h4>
                                    <p>
                                        Caso seja necessário, entraremos em contato. Se você não
                                        conseguir atender nenhuma das ligações, seu pedido poderá
                                        ser negado automaticamente. O valor aprovado em seu cartão
                                        será devolvido e receberá um e-mail informando que seu
                                        pedido foi negado por falta de contato.
                                        <br /> <br />
                                        Informamos que pode estar sendo analisada a compra e não o
                                        comprador. Caso tenha alguma dúvida, entre em contato
                                        pelos nossos canais de atendimento.
                                    </p>
                                </div>
                            </>
                        ) : (
                            <>
                                <div>
                                    <h4>Seu pedido foi aprovado</h4>
                                    {clientId === '352' ? null : (
                                        <p>
                                            Verifique as políticas de liberação do veículo e emissão
                                            do CRLV e CRV. Este parcelamento está em conformidade
                                            com a resolução CONTRAN nº 736/2018 e portaria DENATRAN
                                            nº 149/2018. A quitação dos débitos junto à rede
                                            bancária ocorrerá em até 2 (dois) dias úteis.
                                            <br /> <br />
                                            Caso tenha alguma dúvida, entre em contato pelos nossos
                                            canais de atendimento.
                                        </p>
                                    )}
                                </div>
                            </>
                        )}
                    </ContentDetail>
                    <ContentContact>
                        <ContentContactTitle>
                            <h2>DÚVIDAS? FALE CONOSCO!</h2>
                            <div>
                                <Link target="_blank" href="https://web.facebook.com/zignetbrasil">
                                    <a target="_blank">
                                        <FaFacebook />
                                    </a>
                                </Link>
                                <Link target="_blank" href="https://www.instagram.com/Zignet_oficial/">
                                    <a target="_blank">
                                        <FaInstagram />
                                    </a>
                                </Link>
                                <div>
                                    <Link target="_blank" href="https://www.linkedin.com/company/zignet/">
                                        <a target="_blank">
                                            <FaLinkedin />
                                        </a>
                                    </Link>
                                </div>
                                <Link target="_blank" href="https://api.whatsapp.com/send?phone=5511945491306&text=Ol%C3%A1,%20Zignet">
                                    <a target="_blank">
                                        <FaWhatsapp />
                                    </a>
                                </Link>
                                <Link target="_blank" href="https://www.youtube.com/channel/UC07YZyHWRKS2xIbFptaT8Bg ">
                                    <a target="_blank">
                                        <FaYoutube />
                                    </a>
                                </Link>
                            </div>
                        </ContentContactTitle>
                        <ContentContactDetail>
                            <div>
                                <p>Horário de Funcionamento</p>
                                <span>Seg. a Sex. - 08hs às 19hs</span>
                            </div>
                            <div>
                                <p>Capital de SP e Regiões</p>
                                <span>11 5171-8484</span>
                            </div>
                            <div>
                                <p>Demais Localidades</p>
                                <span>0800 5800 094</span>
                            </div>
                            <div>
                                <p>WhatsApp</p>
                                <span>11 94549-1306</span>
                            </div>
                            <div>
                                <p>E-mail</p>
                                <span>atendimento@zignet.com.br</span>
                            </div>
                        </ContentContactDetail>
                        {/* <div className={styles.nugget1}>
                                <img src={nugget1} alt="Zignet" />
                            </div>
                            <div className={styles.nugget2}>
                                <img src={nugget2} alt="Zignet" />
                            </div> */}
                    </ContentContact>
                </Content>
                <Summary>
                    <p>
                        Resumo do pedido:
                        <span>
                            {`(${new Intl.DateTimeFormat('pt-BR', {
                                day: '2-digit',
                                month: '2-digit',
                                year: '2-digit',
                                hour: '2-digit',
                                minute: '2-digit'
                            }).format(new Date())})`}
                        </span>
                    </p>
                    <SummaryOrder>
                        <p>
                            Número do pedido:{' '}
                            <span>
                                {/* {consultCode !== 0 ? consultCode : storeData?.consultCode} */}
                            </span>
                        </p>
                        {hasAuthToShow?.length > 0 && (
                            <p>
                                Autorização: <span>{hasAuthToShow}</span>
                            </p>
                        )}
                        {hasPaymentCode > 0 && (
                            <p>
                                Transação: <span>{hasPaymentCode}</span>
                            </p>
                        )}

                        <button
                            onClick={() => {
                                showModalDetail(true);
                            }}
                        >
                            Detalhe do pedido
                            <FiChevronRight />
                        </button>
                    </SummaryOrder>
                    <SummaryInstallment>
                        <p>
                            {installments.find((i) => i.checked === true)?.month ||
                                storeData?.installments?.quantity}{' '}
                            x de &nbsp;
                            <span>
                                {new Intl.NumberFormat('pt-BR', {
                                    style: 'currency',
                                    currency: 'BRL'
                                }).format(
                                    Number(
                                        installments.find((i) => i.checked === true)
                                            ?.installmentPrice ||
                                        storeData?.installments?.totalPrice
                                    )
                                )}
                            </span>
                        </p>
                        <p>
                            {new Intl.NumberFormat('pt-BR', {
                                style: 'currency',
                                currency: 'BRL'
                            }).format(
                                Number(
                                    installments.find((i) => i.checked === true)?.totalPrice ||
                                    storeData?.installments?.totalPrice
                                )
                            )}
                        </p>
                    </SummaryInstallment>
                    <SummaryDebts>
                        <p>{'Contas diversas'}</p>
                        <div>
                            <p>
                                {storeData?.consultCode
                                    ? 'Débitos'
                                    : 'Total contas diversas'}
                            </p>
                            <p id="total_value">
                                {new Intl.NumberFormat('pt-BR', {
                                    style: 'currency',
                                    currency: 'BRL'
                                }).format(
                                    ipvaTotal +
                                    dpvatTotal +
                                    multasTotal +
                                    outrosTotal +
                                    licenciamentoTotal || storeData?.installments?.totalPrice
                                )}
                            </p>
                        </div>
                    </SummaryDebts>
                </Summary>
            </Container>
        </>
    );
};

export default Proof;

function useRouter() {
    throw new Error("Function not implemented.");
}
